<template>
    <div >
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white" style="min-height:65vh; display: flex; flex-direction: column;">
            <br /><br /><br />
            <CCol sm="12" style="width: 80%; background-size: cover; margin: auto; color: #fff">
                <br /><br /><br />
                <CRow>
                    <CCol sm="8" style="background-size: cover; margin: auto; color: #fff">
                            <CRow class="p-20 m-3" style="display: block;justify-content: center;">
                                <div class="text-center mt-5">
                                   <img src="../assets/img/Spinner-3.gif" />
                                   <h3 class="font-color-171717 mt-3">Processing...</h3>
                                </div>
                            </CRow>
                            <br /><br />
                    </CCol>
    
                </CRow>
            </CCol>
    
    
    
    
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundGenie,
            isActive: false,

            packages: [],
            details: {},
            refNo: this.$route.query.refNo,
            amount: 0,
        };
    },
    async mounted() {

       this.SubmitData();

    },
    methods: {

        SubmitData() {
            const formData = new FormData();

            formData.append("userId", this.$route.query.userId);
            formData.append("packageId", this.$route.query.packageId);
            formData.append("code", this.$route.query.code);


            return this.$API
                .post(this.$UpdatePaymentPackage, formData)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        //this.successModal = true;
                        this.$router.push("SuccessReceipt?userId=" + this.$route.query.userId + "&packageId=" + this.$route.query.packageId + "&code=" + this.$route.query.code + "&refNo=" + this.$route.query.refNo)
                       
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.status);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";
                    }
                });
                
        },
        async GetDetailPackage() {
            try {
                const response = await this.$API.get(this.$GetPackageCandidateById + "?id=" + this.$route.query.packageId);
                if (response.status === 200) {
                    this.packages = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetSuccessPayment() {
            try {
                const response = await this.$API.get(this.$GetSuccessPaymentSubscription + "?userId=" + this.$route.query.userId);
                if (response.status === 200) {
                    this.details = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        ConvertExchangeRate() {
            this.targetCurrency = this.user.currency;
            this.priceInUSD = this.$route.query.amount;

            // Fetch exchange rate for USD to targetCurrency
            fetch(`https://api.exchangerate-api.com/v4/latest/USD`)
                .then(response => response.json())
                .then(data => {
                    const exchangeRate = data.rates[this.targetCurrency];
                    if (exchangeRate) {
                        this.amount = (this.priceInUSD * exchangeRate).toFixed(2);
                    } else {
                        alert(`Failed to fetch exchange rate for ${this.targetCurrency}`);
                    }
                })
                .catch(error => {
                    console.error('Error fetching exchange rate:', error);
                });
        },
        printPage() {
            window.print();
        }



    },
};
</script>
  
<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}
</style>
  